// extracted by mini-css-extract-plugin
export default {"wrapper":"IndustryHomeHero_wrapper__npGSj","quote":"IndustryHomeHero_quote__PVqE6"};